import TrackIcon from "../icons/TrackIcon";
import PaySecurelyIcon from "../icons/PaySecurelyIcon";
import FastDeliveryIcon from "../icons/FastDeliveryIcon";
import { useTranslation } from "next-i18next";
import InstallmentsIcon from "../icons/InstallmentsIcon";
import FreeShippingIcon from "../icons/FreeShippingIcon";
import WarrantyIcon from "../icons/WarrantyIcon";

const PDPBottom = () => {
  const { t } = useTranslation("product");
  return (
    <div className="flex gap-6 sm:grid p-4 sm:grid-cols-6 sm:gap-2 sm:items-center bg-zinc-100 text-[15px] overflow-x-auto primary-scrollbar">
      <div className="flex flex-col items-center justify-between gap-2 shrink-0">
        <TrackIcon className="size-7 sm:size-10" />
        <span className="font-bold text-primary-800 text-nowrap">
          {t("Track Order")}
        </span>
      </div>
      <div className="flex flex-col items-center justify-between gap-2 shrink-0">
        <PaySecurelyIcon className="size-8 sm:size-10 text-primary-800" />
        <span className="font-bold text-primary-800 text-nowrap">
          {t("Pay Securely")}
        </span>
      </div>
      <div className="flex flex-col items-center justify-between gap-2 shrink-0">
        <FastDeliveryIcon className="size-8 sm:size-12 text-primary-800" />
        <span className="font-bold text-primary-800 text-nowrap">
          {t("Fast Delivery")}
        </span>
      </div>
      <div className="flex flex-col items-center justify-between gap-2 shrink-0">
        <InstallmentsIcon className="size-7 sm:size-10" />
        <span className="font-bold text-primary-800 text-nowrap">
          0% {t("Installments")}
        </span>
      </div>
      <div className="flex flex-col items-center justify-between gap-2 shrink-0">
        <FreeShippingIcon className="size-8 sm:size-12 text-primary-800" />
        <span className="font-bold text-primary-800 text-nowrap">
          {t("Selective free shipping")}
        </span>
      </div>
      <div className="flex flex-col  items-center justify-between gap-2 shrink-0">
        <WarrantyIcon className="size-8 sm:size-12 text-primary-800" />

        <span className="font-bold text-primary-800 flex gap-2 items-center text-nowrap">
          <p>{t("Extended warranty")}</p>
          <div className="border rounded-full w-4 h-4 border-primary-800 relative text-xs has-tooltip flex justify-center items-center">
            <p className="tooltip absolute bg-primary-800 -mt-12 py-1.5 px-2 h-fit text-sm rounded-md bottom-2 text-white">
              {t("For selected items")}
            </p>
            <p className="absolute ">!</p>
          </div>
        </span>
      </div>
    </div>
  );
};

export default PDPBottom;
